import React from "react";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Book from './pages/Book';
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import ContactBarMobile from './components/ContactBarMobile';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
        <Navbar />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/book" exact component={Book} />
          <Route path="/services" component={Services} />
          <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
        </Switch>
        <ContactBarMobile/>
        <Footer/>
    </Router>
  );
}

export default App;
